export enum HintEnum {
    MemberCommission,
    ProxyCommission,
    OperateSummary,
    AgentRebate,
}
